var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState, useEffect } from 'react';
import { Absolute, Text, CloseButton } from 'pcln-design-system';
import styled, { keyframes, css } from 'styled-components';
import analytics from './analytics';
var NotificationBox = styled(Absolute)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  display: flex;\n  align-items: center;\n  border-radius: 6px 12px 20px 24px;\n  cursor: pointer;\n"], ["\n  position: fixed;\n  display: flex;\n  align-items: center;\n  border-radius: 6px 12px 20px 24px;\n  cursor: pointer;\n"])));
var fadeInFromBottomToTopAnimation = function (props) {
    var animation = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  from {\n       transform: translate(", ", ", ");\n      -webkit-transform: translate(", ", ", ");\n       opacity: 0;\n    }\n\n    to {\n       transform: translate(", ", ", ");\n       opacity: 1;\n    }\n  "], ["\n  from {\n       transform: translate(", ", ", ");\n      -webkit-transform: translate(", ", ", ");\n       opacity: 0;\n    }\n\n    to {\n       transform: translate(", ", ", ");\n       opacity: 1;\n    }\n  "])), props.fromX, props.fromY, props.fromX, props.fromY, props.toX, props.toY);
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n    animation: ", ";\n    animation-duration: 0.4s;\n    animation-fill-mode: forwards;\n    animation-timing-function: cubic-bezier(0, 0, 0.3, 1);\n  "], ["\n    position: relative;\n    animation: ", ";\n    animation-duration: 0.4s;\n    animation-fill-mode: forwards;\n    animation-timing-function: cubic-bezier(0, 0, 0.3, 1);\n  "])), animation);
};
var AnimateBottomToTop = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  ", "\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n"])), fadeInFromBottomToTopAnimation);
var AnimateComponent = function (_a) {
    var children = _a.children, animationProperties = _a.animationProperties, animationType = _a.animationType;
    if (animationType === 'BottomToTopLeft' || animationType === 'RightToLeft') {
        var bottom = animationProperties.bottom, from = animationProperties.from, to = animationProperties.to;
        return (React.createElement(AnimateBottomToTop, { fromX: from.x, fromY: from.y, toX: to.x, toY: to.y, bottom: bottom }, children));
    }
    return children;
};
/**
 * ChatBotPopOver
 * chat notification popover
 * @public
 */
export function ChatBotPopOver(props) {
    var onClose = props.onClose, onOpen = props.onOpen, text = props.text, positionProps = props.positionProps, containerProps = props.containerProps, _a = props.animationType, animationType = _a === void 0 ? 'None' : _a, animationProperties = props.animationProperties, source = props.source, isFrequentNotification = props.isFrequentNotification;
    var _b = positionProps !== null && positionProps !== void 0 ? positionProps : {}, zIndex = _b.zIndex, bottom = _b.bottom, right = _b.right;
    var _c = (containerProps !== null && containerProps !== void 0 ? containerProps : {}).width, width = _c === void 0 ? '300px' : _c;
    var _d = useState(true), hidePopOver = _d[0], setHidePopOver = _d[1];
    var today = new Date();
    var startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay());
    startOfWeek.setHours(0, 0, 0, 0);
    useEffect(function () {
        var homePagePopoverLastSaved = localStorage.getItem('homePagePopoverLastSaved');
        var shouldNotShowHomePagePopOver = localStorage.getItem('shouldNotShowHomePagePopOver');
        var homePagePopoverLastSavedDate = homePagePopoverLastSaved
            ? new Date(homePagePopoverLastSaved)
            : null;
        if (isFrequentNotification && homePagePopoverLastSavedDate && shouldNotShowHomePagePopOver) {
            if (source === 'homepage' && shouldNotShowHomePagePopOver === 'false') {
                setHidePopOver(false);
            }
            else if (source !== 'homepage') {
                setHidePopOver(false);
            }
            else {
                if (homePagePopoverLastSavedDate && homePagePopoverLastSavedDate < startOfWeek) {
                    localStorage.setItem('shouldNotShowHomePagePopOver', 'false');
                    localStorage.setItem('homePagePopoverLastSaved', today.toString());
                    setHidePopOver(false);
                }
                else {
                    setHidePopOver(true);
                }
            }
        }
        else {
            setHidePopOver(false);
        }
    }, [isFrequentNotification]);
    var handleHomePageClose = function () {
        if (source === 'homepage' && isFrequentNotification) {
            localStorage.setItem('shouldNotShowHomePagePopOver', 'true');
            localStorage.setItem('homePagePopoverLastSaved', today.toString());
            analytics.fireGA4Event({
                event: 'pcln_home',
                attributes: {
                    event: 'pcln_home',
                    category: 'penny_close',
                    label: 'fab',
                },
            });
        }
    };
    if (hidePopOver) {
        return null;
    }
    return (React.createElement(AnimateComponent, { animationType: animationType, animationProperties: animationProperties },
        React.createElement(NotificationBox, { pt: 3, pb: 3, px: 3, bottom: bottom, right: right, zIndex: zIndex, width: width, boxShadow: 'lg', background: 'background.lightest', color: 'text.base', onClick: function (e) {
                e.stopPropagation();
                e.preventDefault();
                onOpen();
            } },
            React.createElement(Absolute, { bottom: '55px', right: '-10px' },
                React.createElement(CloseButton, { "data-testid": 'CHATBOT_POPOVER_CLOSEBUTTON', title: 'close', variant: 'filled', size: 'md', onClick: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        handleHomePageClose();
                        onClose();
                    } })),
            React.createElement(Text, { fontSize: 1 }, text))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=ChatBotPopOver.js.map